// extracted by mini-css-extract-plugin
export default {"wrapper":"style-module--wrapper--e8269","inFullWidthSection":"style-module--inFullWidthSection--ea3c4"};